<template>
  <div class="doctorPage">
    <div class="doctor-content" v-if="doctor_list.length > 0 && !isShow_Info">
      <ul>
        <li v-for="(item, i) in doctor_list" :key="i" @click="doc_card_click(item)">
          <Icon name="cross" @click.stop="del_doctor(item)" class="del-doctor" />
          <div class="doctor-img">
            <img :src="item.phead" />
          </div>
          <div class="doctor-name">{{ item.pname }}</div>
        </li>
      </ul>
    </div>

    <Popup
      :show="showPicker_doctor"
      destroy-on-close
      position="center"
      :round="true"
      duration="0.1"
      class="create-doctor-popup"
    >
      <div class="create-doctor">
        <div class="create-title">创建医师</div>
        <div class="close-popup" @click="close_create_doctor">
          <Icon name="cross" />
        </div>
        <div class="create-content">

          <div class="form-item">
            <div class="form-label">
              <Icon name="contact" class="form-label-icon" />
              <span>医师姓名</span>
            </div>
            <Field
              class="form-field"
              placeholder="请输入医师姓名（仅中文）"
              v-model="doctor_info.name"
              maxlength="20"
              type="text"
            />
          </div>

          <div class="form-item">
            <div class="form-label">
              <Icon name="photo-o" class="form-label-icon" />
              <span>医师头像</span>
            </div>
            <div class="upload-wrapper">
              <div
                class="avatar-upload"
                :class="{ 'has-preview': avatarPreview }"
                @click="!avatarPreview && triggerUpload()"
              >
                <input
                  ref="fileInputRef"
                  type="file"
                  accept="image/*"
                  style="display:none"
                  @change="onAvatarChange"
                />
                <img v-if="avatarPreview" :src="avatarPreview" class="avatar-preview" />
                <div v-else class="avatar-placeholder">
                  <Icon name="plus" class="avatar-plus-icon" />
                </div>
                <div
                  v-if="avatarPreview"
                  class="avatar-delete-btn"
                  @click.stop="removeAvatar"
                >
                  <Icon name="cross" />
                </div>
              </div>
              <div class="upload-tip">建议上传正方形图片，支持 JPG/PNG</div>
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">
              <Icon name="notes-o" class="form-label-icon" />
              <span>医师简介</span>
              <span class="form-label-count">{{ doctor_info.synopsis.length }}/100</span>
            </div>
            <div class="textarea-wrapper">
              <textarea
                ref="textareaRef"
                id="autoResizeTextarea"
                rows="1"
                maxlength="100"
                v-model="doctor_info.synopsis"
                placeholder="请输入医师简介"
              ></textarea>
            </div>
          </div>

        </div>
        <Button type="primary" block class="doctor-submit" @click="submit_doctor">创建医师</Button>
      </div>
    </Popup>

    <div class="add-doctor" @click="add_doctor" v-if="!isShow_Info">
      <Icon name="plus" />
    </div>

    <DoctorInfo
      :doc_info="select_doctor"
      v-if="isShow_Info"
      :isShowInfo="isShow_Info"
      @update-isShowInfo="handleMessageUpdate"
    />
  </div>
</template>

<script setup>
import { ref, nextTick, onMounted } from "vue";
import { Field, Icon, Popup, Button, showToast, showLoadingToast, closeToast, showSuccessToast } from "vant";
import DoctorInfo from "@/components/video/doctorInfo.vue";
import { put_file, createDoctor, getAllDoctor, delDocter } from "@/api/index";

const showPicker_doctor = ref(false);
const doctor_info = ref({
  name: "",
  head_img: [],
  synopsis: "",
  head_file: null
});
const select_doctor = ref();
const doctor_list = ref([]);
const textareaRef = ref(null);
const fileInputRef = ref(null);
const avatarPreview = ref("");
const isShow_Info = ref(false);
function autoResize() {
  nextTick(() => {
    if (textareaRef.value) {
      textareaRef.value.style.height = "auto";
      textareaRef.value.style.height = textareaRef.value.scrollHeight + "px";
    }
  });
}

onMounted(async ()=>{
       showLoadingToast({
              message: "加载中...",
              duration: 0
       });

       let res = await getAllDoctor()
       doctor_list.value = res.data
       
       closeToast();
})
const handleMessageUpdate = (newValue) => {
  isShow_Info.value = newValue;
};

const doc_card_click = (item) => {
  isShow_Info.value = true;
  select_doctor.value = item;
};

const add_doctor = () => {
  showPicker_doctor.value = true;
  setTimeout(() => {
    if (textareaRef.value) {
      textareaRef.value.addEventListener("input", autoResize);
      autoResize();
    }
  }, 500);
};

const triggerUpload = () => {
  if (fileInputRef.value) fileInputRef.value.click();
};

const onAvatarChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  doctor_info.value.head_file = file;
  const reader = new FileReader();
  reader.onload = (ev) => { avatarPreview.value = ev.target.result; };
  reader.readAsDataURL(file);
};

const removeAvatar = () => {
  avatarPreview.value = "";
  doctor_info.value.head_file = null;
  doctor_info.value.head_img = [];
  if (fileInputRef.value) fileInputRef.value.value = "";
};

const submit_doctor = async () => {
  const chineseRegex = /^[\u4e00-\u9fa5]+$/;
  if (!chineseRegex.test(doctor_info.value.name)) {
    showToast("用户名只能出现中文");
    return;
  }
  if (!doctor_info.value.head_file) {
    showToast("请选择上传图片");
    return;
  }
  if (doctor_info.value.synopsis === "") {
    showToast("请输入医师简介");
    return;
  }

  showLoadingToast({ message: "创建中...", duration: 0 });
  const formData = new FormData();
  formData.append("files[]", doctor_info.value.head_file);
  const response = await put_file(formData);

  const param = {
    pname: doctor_info.value.name,
    pinfo: doctor_info.value.synopsis,
    phead: response.data.MediaUrl
  };
  await createDoctor(param);
  const res = await getAllDoctor();
  doctor_list.value = res.data;

  doctor_info.value = { name: "", head_img: [], synopsis: "", head_file: null };
  avatarPreview.value = "";
  showSuccessToast("创建成功");
  setTimeout(() => { closeToast(); showPicker_doctor.value = false; }, 500);
};

const close_create_doctor = () => {
  showPicker_doctor.value = false;
  doctor_info.value = { name: "", head_img: [], synopsis: "", head_file: null };
  avatarPreview.value = "";
};

const del_doctor = async (item) => {
  showLoadingToast({ message: "删除中...", duration: 0 });
  const is_del = confirm("是否确认删除医师，删除后将无法恢复");
  if (is_del) {
    await delDocter({ pid: item.pid });
    const res = await getAllDoctor();
    doctor_list.value = res.data;
  }
  closeToast();
};
</script>

<style scoped>
.doctorPage {
  height: 100%;
  width: 99%;
  margin: 0 auto;
  position: relative;
  overflow: auto;
}
.add-doctor {
  font-size: 24px;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  position: fixed;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50%;
  bottom: 50px;
  right: 60px;
  box-shadow: 0 4px 14px rgba(79,70,229,0.4);
  cursor: pointer;
  transition: all 0.2s;
  z-index: 100;
}
.add-doctor:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(79,70,229,0.5);
}
.add-doctor:active {
  transform: translateY(0) scale(0.95);
}
.doctor-content ul {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 15px;
  padding: 20px;
}
.doctor-content li {
  height: 150px;
  border: 1px solid rgba(22,22,245,0.3);
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-radius: 15px;
  position: relative;
  text-align: center;
  padding-top: 17px;
  cursor: pointer;
  transition: all 0.2s;
}
.doctor-content li:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.15);
}
.del-doctor {
  cursor: pointer;
  color: #ccc;
  font-size: 15px;
  position: absolute;
  right: 10px;
  top: 10px;
  transition: color 0.2s;
  z-index: 2;
}
.del-doctor:hover {
  color: #ff4d4f;
}
.doctor-img img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}
.doctor-name {
  margin-top: 10px;
  font-size: 15px;
  font-weight: 500;
}
</style>

<style>
.create-doctor-popup.van-popup {
  width: 92% !important;
  max-width: 440px !important;
  max-height: 88vh !important;
  border-radius: 16px !important;
  overflow: hidden !important;
}
.create-doctor {
  display: flex;
  flex-direction: column;
  max-height: 88vh;
}
.create-title {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: center;
  padding: 18px 20px;
  border-bottom: 1px solid #ebedf0;
  position: relative;
  flex-shrink: 0;
}
.close-popup {
  position: absolute;
  right: 16px;
  top: 7%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px !important;
  cursor: pointer;
  transition: all 0.2s;
  color: #999;
}
.close-popup:hover {
  background: #ff4d4f;
  color: #fff;
}
.create-content {
  padding: 24px 20px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.form-label-icon {
  color: #4f46e5;
  font-size: 16px;
}
.form-label-count {
  margin-left: auto;
  font-size: 12px;
  color: #bbb;
  font-weight: 400;
}
.form-field.van-field {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
  background: #fafafa;
  transition: all 0.2s;
}
.form-field.van-field:focus-within {
  border-color: #4f46e5;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(79,70,229,0.08);
}
.upload-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.avatar-upload {
  width: 90px;
  height: 90px;
  border-radius: 12px;
  background: #f5f5f5;
  border: 2px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  overflow: visible;
}
.avatar-upload:hover {
  border-color: #4f46e5;
  background: rgba(79,70,229,0.04);
}
.avatar-preview {
  width: 90px;
  height: 90px;
  border-radius: 12px;
  object-fit: cover;
  display: block;
}
.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.avatar-plus-icon {
  color: #bbb;
  font-size: 24px;
}
.avatar-delete-btn {
  position: absolute;
  top: -9px;
  right: -9px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ff4d4f;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(255,77,79,0.4);
  z-index: 10;
  transition: all 0.2s;
}
.avatar-delete-btn:hover {
  background: #d9363e;
  transform: scale(1.1);
}
.upload-tip {
  font-size: 12px;
  color: #aaa;
}
.textarea-wrapper {
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px 14px;
  transition: all 0.2s;
}
.textarea-wrapper:focus-within {
  border-color: #4f46e5;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(79,70,229,0.08);
}
#autoResizeTextarea {
  width: 100%;
  resize: none;
  overflow-y: hidden;
  padding: 0;
  box-sizing: border-box;
  line-height: 1.6;
  min-height: 60px;
  transition: height 0.2s ease-out;
  font-size: 14px;
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  color: #333;
}
#autoResizeTextarea::placeholder {
  color: #c0c0c0;
}
.doctor-submit.van-button {
  margin: 0 20px 20px !important;
  width: calc(100% - 40px) !important;
  height: 44px !important;
  font-size: 16px !important;
  border-radius: 10px !important;
  background: linear-gradient(135deg, #4f46e5, #7c3aed) !important;
  border: none !important;
  font-weight: 500;
}
.doctor-submit.van-button:active {
  opacity: 0.85;
}
</style>
